export default __webpack_public_path__ + "static/media/contact.66f55e31.png";